export const scrollTopOf = (target) => (target === window ? window.scrollY : target.scrollTop);

// Share of the remaining distance covered each frame, plus a floor so the last
// stretch does not crawl.
const EASING = 0.18;
const MIN_STEP_PX = 24;

const INTERRUPTS = ['wheel', 'touchstart', 'keydown'];

// Native smooth scrolling aims at the offset it worked out when it started, so a
// virtualized list that re-measures rows mid-scroll leaves it short of the top.
// Stepping a share of whatever is left each frame reads the position again every
// time, so it arrives however much the content moves underneath it.
export function scrollToTopSmoothly(target) {
  let stopped = false;

  const stop = () => {
    stopped = true;
    INTERRUPTS.forEach((event) => window.removeEventListener(event, stop));
  };
  // Taking over by hand wins. Our own scrolling fires none of these.
  INTERRUPTS.forEach((event) => window.addEventListener(event, stop, { passive: true }));

  const step = () => {
    if (stopped) {
      return;
    }
    const top = scrollTopOf(target);
    if (top <= 0) {
      stop();
      return;
    }
    target.scrollTo({ top: Math.max(0, top - Math.max(MIN_STEP_PX, top * EASING)) });
    requestAnimationFrame(step);
  };

  requestAnimationFrame(step);
}
